import React, { useState, memo } from "react";
import { Tooltip } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import ImportExportIcon from '@mui/icons-material/ImportExport';
import moment from "moment-jalaali";
import ExcelJS from "exceljs";
import Api from "../../utils/api";
import { useSelector } from "react-redux";
import {Loading} from "../../components";

const MarketerExcelDownload = ({ object }) => {
    const AppState = useSelector((state) => state);
    const [loading, setLoading] = useState(false);

    const fetchData = async () => {
        setLoading(true);
        try {
            const params = { ...object, excel_export: 1 };
            const response = await new Api().get("/marketers", params);
            const items = Array.isArray(response) ? response : [];

            if (items.length > 0) {
                const workbook = new ExcelJS.Workbook();
                const worksheet = workbook.addWorksheet("Marketers");

                worksheet.columns = [
                    { header: "شناسه کاربر", key: "id", width: 15 },
                    { header: "نام و نام خانوادگی", key: "name", width: 30 },
                    { header: "نام کاربری", key: "username", width: 20 },
                    { header: "ایمیل", key: "email", width: 25 },
                    { header: "کد ملی", key: "national_code", width: 20 },
                    { header: "موبایل", key: "mobile", width: 20 },
                    { header: "کد بازاریابی", key: "gov_code", width: 20 },
                    { header: "نام بالاسری", key: "up_id", width: 30 },
                    { header: "لاین", key: "line", width: 15 },
                    { header: "وضعیت", key: "status", width: 20 },
                    { header: "تاریخ ثبت نام", key: "created_at", width: 25 },
                ];

                items.forEach((user) => {
                    worksheet.addRow({
                        id: user.id,
                        name: `${user.user.name} ${user.user.family}`,
                        username: user.user.username || '-',
                        email: user.user.email || '-',
                        national_code: user.info?.national_code || '-',
                        mobile: user.user.mobile || '-',
                        gov_code: user.info?.gov_code || '-',
                        up_id: user.parent ? `${user.parent.name} ${user.parent.family}` : '-',
                        line: user.position || '-',
                        status: AppState.marketer?.status?.[user.user.status] || '-',
                        created_at: moment(user.user.created_at, 'YYYY/MM/DD HH:mm:ss')
                            .locale('fa')
                            .format('jYYYY/jMM/jDD HH:mm:ss'),
                    });
                });

                worksheet.getRow(1).eachCell((cell) => {
                    cell.font = { bold: true, size: 14 };
                    cell.alignment = { horizontal: 'center', vertical: 'middle' };
                    cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFCCEEFF' } };
                    cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
                });

                worksheet.eachRow({ includeEmpty: false }, (row, rowNumber) => {
                    if (rowNumber > 1) {
                        row.eachCell((cell) => {
                            cell.font = { size: 12 };
                            cell.alignment = { horizontal: 'center', vertical: 'middle' };
                        });
                    }
                });

                const buffer = await workbook.xlsx.writeBuffer();
                const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                const url = URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = `marketers_${moment().unix()}.xlsx`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                URL.revokeObjectURL(url);
            }
        } catch (error) {
            console.error('Error exporting marketers:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <Tooltip title="خروجی اکسل">
                <IconButton onClick={fetchData} disabled={loading}>
                    <ImportExportIcon/>
                </IconButton>
            </Tooltip>
            {loading && <Loading/>}
        </>
    );
};

export default memo(MarketerExcelDownload);
